import React from "react";

const SidePillItem = ({ text, isActive, item, onClick }) => {
  return (
    <div
      onClick={() => {
        onClick(item);
      }}
      className={`sidepill-item${isActive ? "-active" : ""}`}
      style={{ width: "100%", display: "block" }}
    >
      <h5>{text}</h5>
    </div>
  );
};

const VerticalCategories = ({
  selectedCategory,
  setSelectedCategory,
  categories = {},
}) => {
  return (
    <div className="d-flex  flex-column">
      {categories.map((cat, index) => {
        return (
          <SidePillItem
            text={cat?.label}
            item={cat}
            onClick={setSelectedCategory}
            isActive={selectedCategory?.label == cat?.label}
            key={index}
          />
        );
      })}
    </div>
  );
};

export default VerticalCategories;
